import { render, staticRenderFns } from "./SupplierRiskModelProfileVerificationForm.vue?vue&type=template&id=cde3b506&scoped=true&"
import script from "./SupplierRiskModelProfileVerificationForm.vue?vue&type=script&lang=js&"
export * from "./SupplierRiskModelProfileVerificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde3b506",
  null
  
)

export default component.exports